// extracted by mini-css-extract-plugin
export default {"modal":"QR-z","error":"RR-z","disabled":"SR-z","fields":"TR-z","errorMsg":"UR-z","footer":"VR-z","formContentWrapper":"WR-z","productImage":"XR-z","overlay":"YR-z"};